import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  InsuranceService,
  BobtailStore,
  DataHelperService
} from './../../shared/index';

@Component({
  selector: 'pax-cf-monthly-rate',
  styles: [require('./monthly-rate.component.sass')],
  template: require('./monthly-rate.component.html')
})
export class MonthlyRateComponent implements OnInit, OnDestroy {
  storeData;
  truckValue;
  trailerValue;
  monthlyRate: number = 0;

  constructor(
    private _store: Store<any>,
    private _insurance: InsuranceService,
    private _helper: DataHelperService
  ) {}

  ngOnInit() {
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      if (this._helper.isEmptyObject(store.steps)) { return false; }

      this.truckValue = store.steps.preliminary['truckValue'] ? this._insurance.currencyToNumber(store.steps.preliminary['truckValue']) : 0;
      this.trailerValue = store.steps.preliminary['trailerValue'] ? this._insurance.currencyToNumber(store.steps.preliminary['trailerValue']) : 0;

      if (!this.truckValue) { return false; }
      this.monthlyRate = this._insurance.getMonthlyRate();
    });
  }

  ngOnDestroy() {
    this.storeData.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/monthly-rate/monthly-rate.component.ts